import { render, staticRenderFns } from "./lending.vue?vue&type=template&id=51145bb3&"
import script from "./lending.vue?vue&type=script&lang=ts&"
export * from "./lending.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports